export default "__VITE_ASSET__49342196__"